import type { AbsenceTimeOffRequestCalculation } from './model';

/** 서버가 계산한 날짜 내역만 설명한다. 시간·반차 수량에서 날짜 제외량을 추정하지 않는다. */
export function absenceDayCountExplanation(calculation?: Pick<AbsenceTimeOffRequestCalculation, 'dayCountBreakdown'>): string | undefined {
  const breakdown = calculation?.dayCountBreakdown;
  if (!breakdown) return undefined;
  if (breakdown.basis === 'CALENDAR_DAYS') return `기간 ${breakdown.selectedDays}일 모두 차감 · 주말·공휴일 포함`;
  return breakdown.excludedDays > 0
    ? `기간 ${breakdown.selectedDays}일 중 ${breakdown.countedDays}일 차감 · 비근무일 ${breakdown.excludedDays}일 제외`
    : `기간 ${breakdown.selectedDays}일 모두 근무일 · ${breakdown.countedDays}일 차감`;
}
